<dashboardnav>
    <div class="box green_box"></div>
    <div class="box pink_box"></div>
    <main class="the_main" [@fadeInAnimation]>
        <cradua-search
            [task]="task"
            (searchEmit)="onSearch($event)"
            (emitTask)="onTask($event)"
            >
        </cradua-search>
        <div [ngSwitch]="task">
            <ng-template ngSwitchCase="list">
                <cradua-adrlist
                    [yearofsuits]="yearofsuits$ | async"
                    [adrProgresss]="adrs$ | async"
                    (dispatchView)="onEmitView($event)"
                    *ngIf="
                    !(isLoadingAdr$ | async)        
                    ">
                </cradua-adrlist>
                <mrsoftapps-epims-reference-spinner
                *ngIf="(isLoadingAdr$ | async)"
                    >
                </mrsoftapps-epims-reference-spinner>
            </ng-template>
            <ng-template ngSwitchCase="create">
                <cradua-viewprogress
                    [yearofsuits]="yearofsuits$ | async"
                    [states]="states$ | async"
                    [lorps]="lorps$ | async"
                    [currencys]="currencys$ | async"
                    [claimtypes]="claimtypes$ | async"
                    [communitiess]="communitiess$ | async"
                    [securityclassifications]="securityclassifications$ | async"
                    [documenttypes]="documenttypes$ | async"
                    [documenttypecodes]="documenttypecodes$ | async"
                    [filelocations]="filelocations$ | async"
                    [lgas]="lgas$ | async"
                    [counseltypes]="counseltypes$ | async"
                    [suitcounsels]="suitcounsels$ | async"
                    [adrProgress]="adrProgresss$ | async"
                    [fetchDocuments]="fetchDocument$ | async"
                    [adrs]="adrs$ | async"
                [isLoadingDocument]="isLoadingDocument$ | async"
                [completed]="completed$ | async"
                [progress]="progress$ | async"
                [error]="error$ | async"
                [isInProgress]="isInProgress$ | async"
                [isReady]="isReady$ | async"
                [hasFailed]="hasFailed$ | async"
                (emitUpload)="uploadFile($event)"
                (emitSaveManyDoc)="onSaveManyDoc($event)"
                (emitCancel)="cancelUpload($event)"
                (emitReset)="resetUpload($event)"
                    [selectedSuitProgresss]="selectedSuitProgresss"
                    (emitSuitSave) = "onSubmit($event)"
                    
                    *ngIf="
                    !(isLoadingYearOfSuits$ | async) &&
                    !(isLoadingStates$ | async) &&
                    !(isLoadingLorps$ | async) &&
                    !(isLoadingCurrencys$ | async) &&
                    !(isLoadingClaimTypes$ | async) &&
                    !(isLoadingCommunitiess$ | async) &&
                    !(isLoadingSecurityClassifications$ | async) &&
                    !(isLoadingDocumentTypes$ | async) &&
                    !(isLoadingDocumentTypeCodes$ | async) &&
                    !(isLoadingFiscalFileLocations$ | async) &&
                    !(isLoadingLgas$ | async) &&
                    !(isLoadingCounselTypes$ | async) &&
                    !(isLoadingAdrProgress$ | async) &&
                    !(isLoadingAdr$ | async) "
                >
                <mrsoftapps-epims-reference-spinner
                    *ngIf="
                    (isLoadingYearOfSuits$ | async) ||
                    (isLoadingStates$ | async) ||
                    (isLoadingLorps$ | async) ||
                    (isLoadingCurrencys$ | async) ||
                    (isLoadingClaimTypes$ | async) ||
                    (isLoadingCommunitiess$ | async) ||
                    (isLoadingSecurityClassifications$ | async) ||
                    (isLoadingDocumentTypes$ | async) ||
                    (isLoadingDocumentTypeCodes$ | async) ||
                    (isLoadingFiscalFileLocations$ | async) ||
                    (isLoadingLgas$ | async) ||
                    (isLoadingCounselTypes$ | async) ||
                    (isLoadingAdrProgress$ | async) ||
                    (isLoadingAdr$ | async)" 
                >
                </mrsoftapps-epims-reference-spinner>
                </cradua-viewprogress>
            </ng-template>
        </div>
    </main>
</dashboardnav>
